// DS1.7.14
import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import s from './BetaBadge.scss';
const BetaBadge = ({ badgeType, variant, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: c(className, s['root'], variant === 'small' && s['small'], variant === 'medium' && s['medium'])
    }, t(`betaBadge.label.var.${badgeType}`));
};
BetaBadge.displayName = 'BetaBadge';
export default BetaBadge;
